<template>
	<div id="area_left1">
		<div class="cc-header">学生请假分析
			<div class="title_tab">
				<div class="legend-color" style="background-color: #df8021;"></div>事假
				<div class="legend-color" style="background-color: #737bee;margin-left: 0.1rem;"></div>病假
			</div>
			<div class="view_btn" @click="showTable">请假明细</div>
		</div>
		<div class="main-value" id="stu_leave"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		showTable() {
			this.$emit("showBigEven", "学生请假明细", "stuLeave");
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let stuLeaveRecordChart = echarts.init(
				document.getElementById("stu_leave")
			);
			this.$http.get("/dataView/platform/getStuLeaveRecord?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var option = {
						tooltip: {
							trigger: 'item'
						},
						grid: {
							top: "10%",
							bottom: "15%",
						},
						series: [{
							name: '人数',
							type: 'pie',
							radius: ['40%', '70%'],
							center: ['50%', '50%'],
							itemStyle: {
								normal: {
									label: {
										formatter: '{b} : {c}',
										textStyle: {
											color: '#34deff',
											fontSize: fontSize(0.12)
										}
									}
								}
							},
							emphasis: {
								label: {
									show: true,
									fontSize: fontSize(0.12),
									color: '#fff'
								}
							},
							data: [
								{
									value: result.sj_count,
									name: '事假',
									itemStyle: {
										color: '#df8021',
									}
								},
								{
									value: result.bj_count,
									name: '病假',
									itemStyle: {
										color: '#737bee',
									}
								}
							]
						}]
					};
					stuLeaveRecordChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => stuLeaveRecordChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#area_left1 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall02.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.7rem;

		.title_tab {
			position: absolute;
			left: 0.3rem;
			top: 0.7rem;
			font-size: 0.18rem;
			height: 0.2rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.25rem;
				height: 0.15rem;
				border-radius: 15%;
				margin-right: 0.05rem;
			}
		}
	}

	.main-value {
		height: 82%;
		margin-top: -20px;
	}

	.view_btn {
		position: absolute;
		right: 0.3rem;
		top: 0.6rem;
		display: inline-block;
		cursor: pointer;
		width: 1rem;
		height: 0.35rem;
		line-height: 0.35rem;
		border-radius: 0.2rem;
		background-image: linear-gradient(135deg, #15517c, #323f86);
		color: #35fff9;
		font-size: 0.15rem;
		z-index: 1;
	}
}
</style>